import { createSelector } from '@reduxjs/toolkit';
import { selectOffersHistory } from './selectOffersHistory';

export const selectOffersHistorySpoilerDataExists = createSelector(
  selectOffersHistory,
  ({ data }) => !!data.listingSpoiler.data?.offers.length,
);
